import { Box, Dialog, DialogContent, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { CommonHelper } from 'src/utils/commonHelper';
import WelcomeImage from '../../assets/app-image/welcome.svg';

const StyledContent = styled('div')(({ theme }) => ({
  minWidth: 600,
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
}));

const WelcomePageForLifeTimeUserComponent = () => {
  const { t: translate } = useTranslation();

  const navigate = useNavigate();
  useEffect(() => {
    const timer = setTimeout(() => {
      let userInfo = CommonHelper.GetBrandInfoFromLocalStorage('user_details')
      if (userInfo) {
        navigate('/get-started');
      } else navigate('/login');
    }, 3000);
    return () => {
      clearTimeout(timer);
    };
  }, []);
  return (
    <>
      <Helmet>
        <title> {translate('welcome_page.welcome')} </title>
      </Helmet>
      <Dialog aria-labelledby="customized-dialog-title" open maxWidth="xl">
        <DialogContent dividers>
          <StyledContent sx={{ textAlign: 'center', alignItems: 'center', mt: 5 }}>
            <Typography variant="h3" paragraph>
              {translate('welcome_page.welcome_two')}
            </Typography>

            <Typography sx={{ color: 'text.secondary' }}>
              {CommonHelper.GetAppName()}, {translate('welcome_page.support_chat_platform')}
            </Typography>

            <Box component="img" src={WelcomeImage} />
          </StyledContent>
        </DialogContent>
      </Dialog>
    </>
  );
};
export default WelcomePageForLifeTimeUserComponent;
